var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"advertisement"},[_c('div',{staticClass:"advertisement_item",on:{"click":_vm.PhoneBill}},[_c('img',{staticClass:"item_img",attrs:{"src":_vm.adOne}})]),_c('div',{staticClass:"advertisement_item",on:{"click":_vm.film}},[_c('img',{staticClass:"item_img",attrs:{"src":_vm.adTwo}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }